import { useEffect, useState } from "react";
import { getValidationScoringConfigBackupByResource } from "../services/scoringService";

const useFetchValidationScoringConfigBackup = ({
  resourceId,
  setIsLoading,
  page,
  pSize,
}: any) => {
  const [backupData, setBackupData] = useState<any>([]);
  useEffect(() => {
    if (resourceId && resourceId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getValidationScoringConfigBackupByResource({
            resourceId,
            page,
            pSize,
          });
          setBackupData(result);
        } catch (err) {
          setBackupData([]);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [resourceId, page, pSize]);

  return [backupData];
};

export default useFetchValidationScoringConfigBackup;

